import React from 'react'

import { Paragraph, Pane, SideSheet, Heading, Card, Button, } from 'evergreen-ui'
import { Link, BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Black from '../Video/Backgorund.mp4'

function ContactPage(props) {
  return(
    <div className="App">
          <video
            autoPlay
            loop
            muted
            style={{
              position: "absolute",
              width: "100%",
              left: "50%",
              top: "50%",
              height: "100%",
              objectFit: "cover",
              transform: "translate(-50%, -50%)",
              zIndex: "-1"
            }}
          >
        <source src ={Black} type="video/mp4" />

        </video>

        <Pane clearfix>

        <Pane
        background="transparent"
        elevation={0}
        float="left"
        width={250}
        height={100}
        marginX={300}
        marginY={100}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        marginLeft={140}
        >
        <Heading size={800} color="goldenrod" marginTop="default">
        Phone:
        <div>
        226-208-7346
        </div>
        <div>
        Email: R.kidd@hotmail.com
        </div>
        <div>
        
        </div>
        </Heading>




        </Pane>
        </Pane>
        </div>
  )
}
export default ContactPage;
